var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLine2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 20 C 5 20, 5 0, 10 0 S 15 20, 20 20",
    stroke: "rgba(132,217,173,1)",
    strokeWidth: 2,
    fill: "none"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLine2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Line2.3691d4d2cdb9d9fa9686422f0e02c74b.svg";